module.exports = __webpack_public_path__ + "media/customizations/onvie/logo-ec9f6c38069d80d64e9e40814e283f59.png";